(() => {
  const listing = () => /^\/(collections|search)(\/|$)/.test(location.pathname);
  document.addEventListener('click', event => {
    const link = event.target.closest('a[href]');
    if (!link || !listing()) return;
    const target = new URL(link.href, location.origin);
    if (target.origin === location.origin && target.pathname.includes('/products/')) {
      try { sessionStorage.setItem('kukur-catalogue-return', JSON.stringify({url: location.href, y: scrollY})); } catch {}
    }
  });
  const back = document.querySelector('.k15-back a');
  if (back) {
    try {
      const saved = JSON.parse(sessionStorage.getItem('kukur-catalogue-return') || 'null');
      const url = saved && new URL(saved.url);
      if (url?.origin === location.origin && /^\/(collections|search)(\/|$)/.test(url.pathname)) {
        back.href = url.href;
        back.addEventListener('click', event => {
          if (event.ctrlKey || event.metaKey || event.shiftKey) return;
          if (document.referrer === saved.url) { event.preventDefault(); history.back(); }
        });
      }
    } catch {}
  }
  const fallback = image => {
    if (!(image instanceof HTMLImageElement) || !image.closest('.product-card__media,.k-search-thumb,.main-photo')) return;
    if (image.dataset.retried) {
      image.hidden = true;
      const note = document.createElement('span');
      note.className = 'photo-empty';
      note.textContent = image.alt || 'Produkto nuotrauka ruošiama';
      image.after(note);
      return;
    }
    image.dataset.retried = 'true';
    image.removeAttribute('srcset');
    const url = new URL(image.src);url.searchParams.delete('width');url.searchParams.delete('height');url.searchParams.delete('crop');image.src = url.href;
  };
  document.addEventListener('error', event => fallback(event.target), true);
  document.querySelectorAll('.product-card img').forEach(img => { if (img.complete && !img.naturalWidth) fallback(img); });
  const sort = document.querySelector('[data-sort-form]');
  if (sort) {
    const params = new URL(location.href).searchParams;
    for (const [name, value] of params) {
      if (name === 'page' || name === 'sort_by' || sort.querySelector(`[name="${CSS.escape(name)}"]`)) continue;
      const input = document.createElement('input');input.type = 'hidden';input.name = name;input.value = value;sort.append(input);
    }
  }
  for (const description of document.querySelectorAll('[data-collection-description]')) description.open = false;
})();

(() => {
  const shuffle = array => {for(let i=array.length-1;i>0;i--){const j=Math.floor(Math.random()*(i+1));[array[i],array[j]]=[array[j],array[i]];}return array;};
  const family = card => {
    const type=(card.dataset.productType||'').toLocaleLowerCase('lt');
    if(/marškin|t-shirt/.test(type))return 'shirt';
    if(/džemper/.test(type))return 'jumper';
    if(/puodel|mug/.test(type))return 'mug';
    return type;
  };
  const init = root => root.querySelectorAll('.catalogue-shelf:not([data-mix-ready])').forEach(shelf=>{
    shelf.dataset.mixReady='true';const grid=shelf.querySelector('.product-grid'),cards=[...grid.children],button=shelf.querySelector('[data-shuffle-shelf]');
    if(!button||!cards.length)return;
    const key='kukur-shelf:'+shelf.dataset.category+':'+new Date().toISOString().slice(0,10);
    const remember=()=>{try{sessionStorage.setItem(key,JSON.stringify([...grid.children].map(c=>c.dataset.productHandle)));}catch{}};
    const arrange=()=>{
      const groups=new Map();for(const card of cards){const type=family(card);if(!groups.has(type))groups.set(type,[]);groups.get(type).push(card);}
      const buckets=shuffle([...groups.values()].map(shuffle));const ordered=[];
      while(buckets.some(bucket=>bucket.length))for(const bucket of buckets)if(bucket.length)ordered.push(bucket.shift());
      grid.append(...ordered);remember();
    };
    let saved;try{saved=JSON.parse(sessionStorage.getItem(key)||'null');}catch{}
    if(saved?.length===cards.length&&cards.every(c=>saved.includes(c.dataset.productHandle)))grid.append(...saved.map(handle=>cards.find(c=>c.dataset.productHandle===handle)));else remember();
    const update=()=>{
      const columns=parseInt(getComputedStyle(grid).getPropertyValue('--shelf-columns'),10)||2,limit=columns*2;
      [...grid.children].forEach((card,index)=>card.hidden=index>=limit);
      button.hidden=cards.length<=limit;
    };
    button.addEventListener('click',()=>{arrange();update();shelf.querySelector('[data-shuffle-status]').textContent='';requestAnimationFrame(()=>shelf.querySelector('[data-shuffle-status]').textContent=shelf.querySelector('[data-shuffle-status]').dataset.message);});
    update();new ResizeObserver(update).observe(grid);
  });
  init(document);document.addEventListener('shopify:section:load',event=>init(event.target));
})();
